






































import { Component, Watch, Vue } from 'vue-property-decorator'
import FieldBase from '@/app/components/Field/FieldBase.vue'
import Loading from '@/app/components/Common/Loading.vue'

@Component({
  components: {
    Loading,
    FieldBase
  },
  head: {
    meta: [{
      name: 'v-jit:version',
      content: process.env.VUE_APP_VERSION
    }]
  }
})
export default class App extends Vue {
  private showField: boolean = false

  @Watch('$route')
  changePath (newValue: any) : void {
    if (newValue.name === 'field') {
      this.showField = true
    } else {
      this.showField = false
    }
  }
}
